import React from "react";
import ModalHeader from "@/customComponents/uiComponents/modal/ModalHeader.jsx";

export function AfterPay({setStep, closeModal, previousStep}) {
    return (
        <>
            <ModalHeader title="" extraClasses="" totalSteps={0} cancelButton={false} cancelButtonType="text" backStep={previousStep} showBackButton={true} enableEditModeOnBackButton={false} setStep={setStep} closeModal={closeModal}/>
            <div className="modalPages-spacing pb-8">
                After Pay Coming Soon
            </div>
        </>
    );
}
export default AfterPay;
